import {
  VUEX_PHOTOS_FETCH,
  VUEX_PHOTOS_FETCH_NEXT_PAGE,
  VUEX_PHOTOS_FETCH_SUCCESS,
  VUEX_PHOTOS_FETCH_FAILURE,

  VUEX_PHOTOS_STATE_UPDATE,

  VUEX_PHOTOS_CLEAR
} from '@/store/constants/models/photos'

import {
  VUEX_API_PHOTOS_FETCH_STREAMING
} from '@/store/constants/api'

// rows asked for per request; the grid asks for the next page when it scrolls to the end
const PAGE_SIZE = 200
// rows shown before the first page has finished, so the grid is not empty while it streams
const FIRST_PAINT_ROWS = 100

let tempPhotos = []
// callbacks of a search that was replaced or cleared are ignored
let searchId = 0

const state = {
  totalCount: 0,
  photos: [],
  // the search the loaded pages belong to, and where the next page starts
  query: null,
  nextSkip: 0
}

const getters = {
  photosHasMore: state => !!state.query && state.nextSkip < state.totalCount
}

function fetchPage ({ state, commit, dispatch }) {
  const pageSearchId = searchId
  const skip = state.nextSkip

  return dispatch(VUEX_API_PHOTOS_FETCH_STREAMING, {
    query: state.query,
    skip,
    limit: PAGE_SIZE,
    // the first page counts the search; later ones know how many rows they get from that
    expectedRows: skip > 0 ? Math.min(PAGE_SIZE, state.totalCount - skip) : undefined,
    callback: data => {
      if (pageSearchId !== searchId) return
      commit(VUEX_PHOTOS_STATE_UPDATE, { ...data, skip })
    }
  })
}

const actions = {
  [VUEX_PHOTOS_FETCH]: ({ state, commit, dispatch }, payload) => {
    searchId++
    commit(VUEX_PHOTOS_FETCH, payload)

    fetchPage({ state, commit, dispatch }).catch(() => {
      // clears photos state on failure/cancel
      commit(VUEX_PHOTOS_FETCH, payload)
    })
  },

  [VUEX_PHOTOS_FETCH_NEXT_PAGE]: ({ state, getters, rootState, commit, dispatch }) => {
    if (!getters.photosHasMore || rootState.apiPhotos.photosRequest === ITS__API__REQUEST_TYPE__PENDING) return

    fetchPage({ state, commit, dispatch }).catch(err => {
      console.error('VUEX_PHOTOS_FETCH_NEXT_PAGE', err)
    })
  },

  [VUEX_PHOTOS_CLEAR]: ({ commit }) => {
    searchId++
    commit(VUEX_PHOTOS_CLEAR)
  }
}

const mutations = {
  [VUEX_PHOTOS_FETCH]: (state, query) => {
    state.photos = []
    state.totalCount = 0
    state.query = query || null
    state.nextSkip = 0
    tempPhotos = []
  },

  [VUEX_PHOTOS_FETCH_SUCCESS]: (state, data) => {
    //
  },

  [VUEX_PHOTOS_FETCH_FAILURE]: (state, data) => {
    //
  },

  [VUEX_PHOTOS_STATE_UPDATE]: (state, data) => {
    if (data.totalCount !== undefined) {
      state.totalCount = data.totalCount
    }

    if (data.items) {
      tempPhotos.push(...data.items)

      if (!state.photos.length && tempPhotos.length === FIRST_PAINT_ROWS) {
        state.photos = [...tempPhotos]
      }
    }

    if (data.pageDone) {
      state.nextSkip = data.skip + PAGE_SIZE
      state.photos = [...tempPhotos]
    }

    if (data.pageFailed) {
      // drop the part of the page that arrived, so asking for it again does not repeat rows
      tempPhotos.splice(data.skip)
      state.photos = [...tempPhotos]
    }
  },

  [VUEX_PHOTOS_CLEAR]: state => {
    state.photos = []
    state.totalCount = 0
    state.query = null
    state.nextSkip = 0
    tempPhotos = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
